import React from 'react';

/**
 * Lists accounts saved via Remember Me so the user can continue without re-entering credentials.
 */
const RememberedAccountsList = ({
  accounts,
  onContinue,
  onRemove,
  continuingUserId,
}) => {
  if (!accounts?.length) {
    return null;
  }

  return (
    <div className="mb-6">
      <p className="text-sm font-medium text-jet-gray-700 mb-3">Continue as</p>
      <ul className="space-y-2">
        {accounts.map(({ userId, user }) => {
          const displayName = [user?.first_name, user?.last_name].filter(Boolean).join(' ') || 'Account';
          const isContinuing = continuingUserId === userId;

          return (
            <li
              key={userId}
              className="flex items-center gap-3 border border-jet-gray-200 rounded-md p-3 bg-jet-gray-50"
            >
              {user?.image_url ? (
                <img
                  src={user.image_url}
                  alt=""
                  className="w-10 h-10 rounded-full object-cover shrink-0"
                />
              ) : (
                <div className="w-10 h-10 rounded-full bg-jet-yellow/30 flex items-center justify-center shrink-0 text-sm font-semibold text-jet-gray-700">
                  {(user?.first_name?.[0] || user?.email?.[0] || '?').toUpperCase()}
                </div>
              )}
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-jet-gray-900 truncate">{displayName}</p>
                <p className="text-xs text-jet-gray-500 truncate">{user?.email}</p>
              </div>
              <div className="flex flex-col gap-1 shrink-0">
                <button
                  type="button"
                  disabled={Boolean(continuingUserId)}
                  onClick={() => onContinue(userId)}
                  className="text-xs font-semibold text-jet-gray-900 bg-jet-yellow px-3 py-1.5 rounded hover:bg-jet-yellow-hover disabled:opacity-50"
                >
                  {isContinuing ? 'Signing in...' : 'Continue'}
                </button>
                <button
                  type="button"
                  disabled={Boolean(continuingUserId)}
                  onClick={() => onRemove(userId)}
                  className="text-xs text-jet-gray-500 hover:text-jet-gray-800 disabled:opacity-50"
                >
                  Remove
                </button>
              </div>
            </li>
          );
        })}
      </ul>
      <p className="text-xs text-jet-gray-500 text-center mt-4">Or sign in with another account below</p>
    </div>
  );
};

export default RememberedAccountsList;
